import React from 'react';
import { motion } from 'framer-motion';
export function HookSection() {
  return <section className="py-10 md:py-20 px-4 bg-white relative" data-id="element-88">
      <div className="max-w-3xl mx-auto text-center" data-id="element-89">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-90">
          <div className="flex justify-center mb-4 md:mb-8" data-id="element-91">
            <div className="w-16 h-1 bg-gold rounded-full" data-id="element-92"></div>
          </div>

          <p className="text-xl md:text-2xl leading-relaxed text-charcoal font-medium" data-id="element-93">
            ¿Alguna vez te has despertado sintiendo que el día ya te ganó la
            batalla antes de levantarte de la cama?
          </p>

          <p className="mt-6 text-lg md:text-xl leading-relaxed text-charcoal/80" data-id="element-94">
            Abres los ojos y lo primero que sientes es el peso de las
            preocupaciones, las noticias de crisis y esa lista interminable de
            pendientes que parece no tener fin. Sientes que tu fe es real, pero
            en el ajetreo diario, Dios se siente lejano.
          </p>

          <p className="mt-8 text-2xl font-heading font-bold text-teal-dark italic" data-id="element-95">
            No eres la única persona que se siente así.
          </p>
        </motion.div>
      </div>
    </section>;
}